import { createSlice } from "@reduxjs/toolkit";

const initialChatHistory = () => {
  const storedHistory = localStorage.getItem('chatHistory');
  return storedHistory ? JSON.parse(storedHistory) : [];
};

const chatSlice = createSlice({
  name: "chat",
  initialState: {
    chatHistory: initialChatHistory(), // 从 localStorage 加载初始状态
  },
  reducers: {
    addMessage: (state, action) => {
      state.chatHistory.push(action.payload);
      localStorage.setItem('chatHistory', JSON.stringify(state.chatHistory)); // 每次更新后存储到 localStorage
    },
    setChatHistory: (state, action) => {
      state.chatHistory = action.payload;
    },
  },
});

export const { addMessage, setChatHistory } = chatSlice.actions;
export default chatSlice.reducer;